namespace $.$$ {

	export class $rise_drag_view extends $.$rise_drag_view {
		
		repos_x( val: number ): number {
			return val
		}
		
		repos_y( val: number ): number {
			return val
		}
		
	}
	
}
